import { setCookieData } from '@repo/common-utils';
import { AuthGuard } from '@repo/user-session';
import { useIsomorphicLayoutEffect } from 'react-use';

import Layout from '@/components/layout/Layout';
import { AUTO_LOGIN_CODE_KEY } from '@/components/tax-refund/common/data/auth-info';
import { CHECK_DECISION_ACTION_CODE_COOKIE_KEY } from '@/components/tax-refund/common/data/result-refund-data';
import TrrStartContent from '@/components/trr/TrrStartContent';

/**
 * 결정확인 알림톡 | 신고서식 재수집 | 고용증대 사후관리 알림톡
 * @constructor
 */
const TrrPage = () => {
  useIsomorphicLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const code = params.get('code');
    const actionCode = params.get('actionCode');
    if (code) {
      sessionStorage.setItem(AUTO_LOGIN_CODE_KEY, code as string);
    }

    if (actionCode) {
      setCookieData(CHECK_DECISION_ACTION_CODE_COOKIE_KEY, actionCode, {
        maxAge: 60 * 60 * 12
      });
    }
  }, []);

  return (
    <AuthGuard logoutPagePath={'/404'}>
      <Layout>
        <TrrStartContent />
      </Layout>
    </AuthGuard>
  );
};

export default TrrPage;
